import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import ErrorMsg from 'components/ErrorMsg';
import Controls from 'containers/request/Initial/Agreements/AgreementsControls';
import LicenseAgreement from 'containers/request/Initial/Agreements/LicenseAgreement';
import { getAgreementInfo, cleanAgreementInfo } from 'actions/agreement';
import { startPreloader, finishPreloader } from 'actions/preloader';
import 'containers/request/Initial/Agreements/style.css';

class Agreements extends Component {
  componentDidMount() {
    const {
      request,
      startPreloader,
      finishPreloader,
      getAgreementInfo,
      cleanAgreementInfo
    } = this.props;

    if (request.model && !_.isUndefined(request.model.id)) {
      startPreloader();
      getAgreementInfo(request.model.id, finishPreloader);
    } else {
      cleanAgreementInfo();
    }
  }

  componentWillUnmount() {
    this.props.cleanAgreementInfo();
  }

  render() {
    const { show, request, history } = this.props;

    if (!show) return null;

    if (request && request.submitError) {
      return <ErrorMsg error={request.submitError} history={history} />;
    }

    return (
      <div>
        <LicenseAgreement />
        <Row>
          <Controls />
        </Row>
      </div>
    );
  }
}

Agreements.propTypes = {
  show: PropTypes.bool
};

Agreements.defaultProps = {
  show: true
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(
  mapStateToProps,
  {
    startPreloader,
    finishPreloader,
    getAgreementInfo,
    cleanAgreementInfo
  }
)(Agreements);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Agreements/index.js